// extracted by mini-css-extract-plugin
export default {"viewTab":"viewTab_viewTab__YGHgt","viewTabSpan":"viewTab_viewTabSpan__NjPPr","viewTabSelected":"viewTab_viewTabSelected__P9Pz6"};